import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "pb-2 border-b" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-3/4 text-left" }, " Pending Invitations ")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " Knowledge is Social, so why not invite others to join ReGrok? ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "text-xs text-green-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.invitationsLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading... "))
    : ($setup.invitationQueryError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Error: " + _toDisplayString($setup.invitationQueryError.message), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            ($setup.invitations == undefined || $setup.invitations?.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invitations, (invite) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: invite.email,
                "data-test-id": "invite"
              }, [
                _createElementVNode("td", {
                  class: "relative w-auto mr-2 whitespace-nowrap overflow-ellipsis",
                  "aria-label": invite.email
                }, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => ($setup.deleteInvite(invite.id)),
                    "data-test-id": "remove-invitation-button",
                    class: "absolute -left-6 mt-2"
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: _normalizeClass(["h-6 w-6", 'w-3 h-3 text-gray-600 hover:text-red-700 transition-colors duration-300']),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "svg-inline": '',
                      role: 'presentation',
                      focusable: 'false',
                      tabindex: '-1'
                    }, _hoisted_11))
                  ], 8, _hoisted_9),
                  _createElementVNode("div", null, _toDisplayString(invite.email), 1),
                  (!invite.accepted)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, " User Invited "))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_8)
              ]))
            }), 128))
          ])
        ]))
}